module.exports = "/static/assets/6536d2d814262dd5860b9ff6a89af64e.png";